<template>
  <div class="block-container" :style="blockStyle"></div>
</template>

<script>
export default {
  name: "TumengBlock",
  components: {},
  props: {
    conf: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showIdx: 0,
    };
  },
  computed: {
    blockStyle() {
      const borderWidth = this.conf.borderWidth ? this.conf.borderWidth + 'px' : 0
      const borderColor = this.conf.borderColor
      const border = `${borderWidth} solid ${borderColor}`
      const { leftTop, rightTop, rightBottom, leftBottom } =
        this.conf.borderRadius;
      const borderRadius = `${leftTop}px ${rightTop}px ${rightBottom}px ${leftBottom}px`;
      
      return {
        boxSize: 'border-box',
        overflow: "hidden",
        border: border,
        borderRadius,
        background: this.conf.bgColor
      };
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.block-container {
  width: 100%;
  height: 100%;
  > img {
    display: block;
    width: 100%;
    height: 100%;
  }
}
</style>
